/* @flow */
import qs from 'qs';
import ListenerManager from '../utilities/ListenerManager';
import {selectAll} from '../utilities/select';
import shorthandToSeconds from '../utilities/shorthandToSeconds';
import type {Module} from '../types';

const listeners: ListenerManager = new ListenerManager;

const makeIframe: Function = (url: string): HTMLIFrameElement => {
  const iframe: HTMLIFrameElement = document.createElement('iframe');
  iframe.setAttribute('frameborder', '0');
  iframe.setAttribute('allowfullscreen', 'true');
  iframe.setAttribute('webkitallowfullscreen', 'true');
  iframe.setAttribute('mozallowfullscreen', 'true');
  iframe.setAttribute('src', url);

  return iframe;
};

const addYoutubeEmbed: EventHandler = (e: Event): void => {
  e.preventDefault();
  const target: EventTarget = e.currentTarget;
  if (!(target instanceof Element)) {
    return;
  }

  // Do nothing if the video embed already exists
  if (target.getElementsByTagName('iframe').length > 0) {
    return;
  }

  // Do nothing if the video ID isn't specified
  const videoId: ?string = target.getAttribute('data-video-id');
  if (!videoId) {
    return;
  }

  const listId: ?string = target.getAttribute('data-list-id');
  const time: ?string = target.getAttribute('data-time');
  const query: string = qs.stringify({
    wmode: 'transparent',
    modestbranding: 1,
    rel: 0,
    showinfo: 0,
    autohide: 1,
    color: 'white',
    iv_load_policy: 3,
    theme: 'dark',
    autoplay: 1,
    list: listId,
    start: shorthandToSeconds(time) || null
  }, {skipNulls: true});

  target.appendChild(
    makeIframe('https://www.youtube.com/embed/' + videoId + '?' + query)
  );
};

const video: Module = {
  init(): void {
    this.destroy();

    selectAll('.js-youtube-embed').forEach((el: Element) => {
      listeners.add(el, 'click', addYoutubeEmbed, false);
    });
  },
  destroy(): void {
    listeners.removeAll();
  }
};

export default video;



// WEBPACK FOOTER //
// ./resources/assets/magazine/js/magazine/video.js